'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin: ', ';\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin: ', ';\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n\n  /* react-datepicker inserts an empty div around the input */\n  > div {\n    width: 100%;\n  }\n\n  .react-datepicker-wrapper,\n  .react-datepicker__input-container {\n    width: 100%;\n  }\n\n  .react-datepicker__navigation--years-previous,\n  .react-datepicker__navigation--years-upcoming {\n    border: 0.45rem solid transparent;    \n    height: 10px;\n    width: 10px;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    border-top-color: #ccc;\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #ccc;\n  }\n\n  .react-datepicker__input-container input {\n    ', '\n\n    background: ', ';\n    border: 1px solid ', ';\n    box-shadow: ', ';\n    font-size: ', ';\n    height: ', ';\n    padding: 0 ', ';\n    \n    &:disabled {\n      background-color: ', ';\n      border: 1px solid ', ';\n      box-shadow: none;\n      cursor: default;\n    }\n\n    &::placeholder {\n      font-style: italic;\n    }\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n\n  /* react-datepicker inserts an empty div around the input */\n  > div {\n    width: 100%;\n  }\n\n  .react-datepicker-wrapper,\n  .react-datepicker__input-container {\n    width: 100%;\n  }\n\n  .react-datepicker__navigation--years-previous,\n  .react-datepicker__navigation--years-upcoming {\n    border: 0.45rem solid transparent;    \n    height: 10px;\n    width: 10px;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    border-top-color: #ccc;\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #ccc;\n  }\n\n  .react-datepicker__input-container input {\n    ', '\n\n    background: ', ';\n    border: 1px solid ', ';\n    box-shadow: ', ';\n    font-size: ', ';\n    height: ', ';\n    padding: 0 ', ';\n    \n    &:disabled {\n      background-color: ', ';\n      border: 1px solid ', ';\n      box-shadow: none;\n      cursor: default;\n    }\n\n    &::placeholder {\n      font-style: italic;\n    }\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n'], ['\n  color: ', ';\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 2rem;\n  font-size: ', ';\n  margin-left: 1rem;\n  cursor: ', ';\n'], ['\n  color: ', ';\n  font-size: 2rem;\n  font-size: ', ';\n  margin-left: 1rem;\n  cursor: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _faCalendarAlt = require('@fortawesome/free-solid-svg-icons/faCalendarAlt');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _em = require('polished/lib/helpers/em');

var _em2 = _interopRequireDefault(_em);

require('react-datepicker/dist/react-datepicker.css');

var _mixins = require('../../mixins');

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DatePickerWrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.margin;
});

DatePickerWrapper.displayName = 'DatePickerWrapper';

var ReactDatePickerWrapper = _styledComponents2.default.div(_templateObject2, (0, _mixins.InputReset)(), _config.colors.white, function (props) {
  return props.$invalid ? _config.colors.red : _config.colors.gray;
}, function (props) {
  return props.$invalid ? '0 0 0 1px ' + _config.colors.red : 'none';
}, (0, _rem2.default)('16px', _config.typography.baseFontSize), (0, _rem2.default)('40px', _config.typography.baseFontSize), (0, _em2.default)('15px', _config.typography.baseFontSize), _config.colors.gray, _config.colors.gray);

ReactDatePickerWrapper.displayName = 'ReactDatePickerWrapper';

var Label = _styledComponents2.default.label(_templateObject3, function (props) {
  return props.variant === 'primary' ? _config.colors.black : _config.colors.white;
});

Label.displayName = 'Label';

var CalendarIcon = _styledComponents2.default.span(_templateObject4, function (props) {
  return props.variant === 'primary' ? _config.colors.darkBlue : _config.colors.white;
}, (0, _rem2.default)('32px', _config.typography.baseFontSize), function (props) {
  return props.disabled ? 'default' : 'pointer';
});

CalendarIcon.displayName = 'CalendarIcon';

var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.dateInputRef = _react2.default.createRef();
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          id = _props.id,
          label = _props.label,
          selected = _props.selected,
          variant = _props.variant,
          invalid = _props.invalid,
          disabled = _props.disabled,
          margin = _props.margin,
          restProps = _objectWithoutProperties(_props, ['id', 'label', 'selected', 'variant', 'invalid', 'disabled', 'margin']);

      return _react2.default.createElement(
        DatePickerWrapper,
        {
          margin: margin
        },
        _react2.default.createElement(
          Label,
          {
            htmlFor: id,
            variant: variant
          },
          label
        ),
        _react2.default.createElement(
          ReactDatePickerWrapper,
          {
            $invalid: invalid
          },
          _react2.default.createElement(_reactDatepicker2.default, _extends({
            id: id,
            selected: selected ? (0, _moment2.default)(selected).toDate() : undefined,
            disabled: disabled,
            disabledKeyboardNavigation: true,
            ref: this.dateInputRef,
            dateFormat: ['MM/dd/yyyy', 'M/d/yyyy', 'MM/d/yyyy', 'M/dd/yyyy']
          }, restProps)),
          _react2.default.createElement(
            CalendarIcon,
            {
              disabled: disabled,
              variant: variant,
              onClick: function onClick() {
                _this2.dateInputRef.current.input.click();
              }
            },
            _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _faCalendarAlt.faCalendarAlt })
          )
        )
      );
    }
  }]);

  return DatePicker;
}(_react2.default.Component);

DatePicker.propTypes = {
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired,
  selected: _propTypes2.default.instanceOf(Date),
  minDate: _propTypes2.default.instanceOf(Date),
  maxDate: _propTypes2.default.instanceOf(Date),
  onSelect: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  variant: _propTypes2.default.oneOf(['primary', 'secondary']),
  placeholder: _propTypes2.default.string,
  invalid: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  margin: _propTypes2.default.string
};

DatePicker.defaultProps = {
  minDate: undefined,
  maxDate: undefined,
  selected: undefined,
  variant: 'primary',
  placeholder: '',
  invalid: false,
  disabled: false,
  margin: ''
};

DatePicker.displayName = 'DatePicker';

exports.default = DatePicker;
DatePicker.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'DatePicker',
  'props': {
    'minDate': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'instanceOf',
        'value': 'Date'
      },
      'required': false,
      'description': ''
    },
    'maxDate': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'instanceOf',
        'value': 'Date'
      },
      'required': false,
      'description': ''
    },
    'selected': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'instanceOf',
        'value': 'Date'
      },
      'required': false,
      'description': ''
    },
    'variant': {
      'defaultValue': {
        'value': '\'primary\'',
        'computed': false
      },
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'primary\'',
          'computed': false
        }, {
          'value': '\'secondary\'',
          'computed': false
        }]
      },
      'required': false,
      'description': ''
    },
    'placeholder': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'invalid': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'margin': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': ''
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'label': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'onSelect': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': ''
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': ''
    }
  }
};